// calculatorNode.js - Performs mathematical calculations

import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const CalculatorNode = ({ id, data }) => {
  const [operation, setOperation] = useState(data?.operation || 'add');

  const handles = [
    { id: 'input1', type: 'target', position: Position.Left, top: 25 },
    { id: 'input2', type: 'target', position: Position.Left, top: 50 },
    { id: 'result', type: 'source', position: Position.Right }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      title="Calculator"
      description="Perform math operations"
      handleConfig={handles}
      width={200}
      height={160}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '12px' }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
          <span style={{ fontWeight: '500', color: '#555' }}>Operation:</span>
          <select 
            value={operation}
            onChange={(e) => setOperation(e.target.value)}
            style={{
              padding: '4px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '12px'
            }}
          >
            <option value="add">Add (+)</option>
            <option value="subtract">Subtract (-)</option>
            <option value="multiply">Multiply (*)</option>
            <option value="divide">Divide (/)</option>
          </select>
        </label>
      </div>
    </BaseNode>
  );
};
